import { useEffect, useState } from 'react';
import { useTimer } from 'react-timer-hook';

// import { t } from 'i18next';

import { useTimerLogic } from 'modules/Room/game-status/components/play-game-statuses/hooks/use-timer-logic';
import { useGameStatusStore } from 'modules/Room/game-status/store/game-status-store';

// import AnimatedTransition from 'shared/components/ui/AnimatedTransition/AnimatedTransition';
// import {
//   CountdownTimer,
//   CountdownTimerType,
// } from 'shared/components/ui/CountdownTimer/CountdownTimer';
import { useRoomStore } from 'shared/store/roomStore';
import { epochToLocalUTC } from 'shared/utils/time';

import { useRevealStatusText } from './use-reveal-status-text';

export const WaitYourRevealStatus = () => {
  const [showTimer, setShowTimer] = useState(false);
  const [showCloseButton, setShowCloseButton] = useState(false);
  const [technicalDefeatError, setTechnicalDefeatError] = useState(false);
  const { setRevealGameStatusError } = useGameStatusStore();
  const { closerRoom } = useRoomStore();

  const { onExpire } = useTimerLogic({
    gameStatusName: 'waitYourReveal',
    setShowTimer,
    setShowCloseButton,
    setTechnicalDefeatError,
  });

  useTimer({
    expiryTimestamp: epochToLocalUTC(closerRoom?.deadline),
    onExpire: onExpire,
  });

  useEffect(() => {
    return () => {
      setRevealGameStatusError({ error: false, reject: false });
    };
  }, [setRevealGameStatusError]);

  const { getTextComponent } = useRevealStatusText(
    showTimer,
    showCloseButton,
    technicalDefeatError,
  );

  return (
    <>
      {getTextComponent()}
      {/* <AnimatedTransition show={showTimer && !showCloseButton}>
        <CountdownTimer
          expiryTimestamp={epochToLocalUTC(closerRoom?.deadline)}
          onComplete={onExpire}
          type={CountdownTimerType.WARNING}
          description={t('modals.waitYourReveal.timerDescription')}
        />
      </AnimatedTransition> */}
    </>
  );
};
